// src/components/skymap/SkyMap.jsx
import React from 'react';

const SkyMap = () => {
  return (
    <div className="sky-map-container">
      <h1>Interactive Sky Map</h1>
      <p>This feature is coming soon. Stay tuned!</p>
      
      <div className="placeholder-content">
        <div className="placeholder-card">
          <h2>What You'll See Here Soon</h2>
          <ul>
            <li>Real-time interactive star map based on your location</li>
            <li>View stars, planets, and constellations</li>
            <li>Time controls to see the night sky at different times</li>
            <li>Information about celestial objects when you click on them</li>
            <li>Custom views and observing lists</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SkyMap;